import { library } from "@fortawesome/fontawesome-svg-core"

let mixin = {
    methods: {
        async fetchIcon () {}
    }
}

if (process.env.NODE_ENV !== "development") {
    mixin = {
        methods: {
            async fetchIcon () {
                this.fetched = false
                let response = await import(/* webpackChunkName: "fonts/[request]" */ "@fortawesome/pro-" + this.iconType + "-svg-icons/" + this.iconFileName + ".js")
                this.fetched = true

                if (response && response.definition) {
                    this.fetchedIcon = response.definition
                    library.add(response.definition)
                }
            }
        }
    }
}

export default mixin
